// @flow

// Method priority. Lower is better.
const methodPriority = ['bundle', 'package', 'selected'];

export default (methods: Array<string>) => methodPriority.find(method => methods.includes(method));
